import React from 'react'

const NotFoundPage = () => {
  return (
    <div>Opps!! You are on the wrong path.</div>
  )
}

export default NotFoundPage
